import { ChangeDetectionStrategy, Component, ElementRef, HostListener } from '@angular/core';
import { EventService,  RoutingService } from '@spartacus/core';
import { Observable, Subscription } from 'rxjs';
import { FocusConfig, ICON_TYPE, LaunchDialogService } from "@spartacus/storefront";
import { take, tap } from 'rxjs/operators';
import { GenFavoritesListItem } from 'src/app/generac/models/favorites.model';
import { GenFavoritesService } from 'src/app/generac/services/favorites.service';
import { GenFavotitesDialogActionsEnum } from 'src/app/generac/enums/favorites-dialogs-actions.enum';

@Component({
    selector: 'gen-create-or-edit-favorites-list-dialog',
    templateUrl: './create-or-edit-favorites-list-dialog.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class GenCreateOrEditFavoritesListDialogComponent {
  private subscription = new Subscription();
  iconTypes = ICON_TYPE;
  userId: string;
  mode: GenFavotitesDialogActionsEnum;
  list: GenFavoritesListItem;
  loading: boolean = false;
  fallbackName: string;

  focusConfig: FocusConfig = {
    trap: true,
    block: true,
    autofocus: 'button',
    focusOnEscape: true,
  };

  @HostListener('click', ['$event'])
  handleClick(event: UIEvent): void {
    // Close on click outside the dialog window
    if ((event.target as any).tagName === this.el.nativeElement.tagName) {
      this.close('Cross click');
    }
  }

  constructor(
    protected launchDialogService: LaunchDialogService,
    protected el: ElementRef,
    protected eventService: EventService,
    protected routingService: RoutingService,
    protected genFavoritesService: GenFavoritesService
  ) { }

  ngOnInit(): void {
    this.subscription.add(
      this.launchDialogService.data$.subscribe(
        (data: any) => {
          this.userId = data.userId;
          this.mode = data.list?.id ? GenFavotitesDialogActionsEnum.Edit : GenFavotitesDialogActionsEnum.Create;
          this.list = data.list;
          this.fallbackName = data.list?.name;
        }
      )
    );
  }

  private renameList(listName: string): Observable<GenFavoritesListItem> {
    return this.genFavoritesService.renameFavoritesList(this.userId, this.list?.id, listName);
  };

  private createList(listName: string): Observable<GenFavoritesListItem> {
    return this.genFavoritesService.createFavoritesList(this.userId, listName);
  };

  public createOrEditFavoritesList(listName: string): Subscription {
    this.loading = true;
    const request = this.mode == GenFavotitesDialogActionsEnum.Edit ? this.renameList(listName) : this.createList(listName);
    return request.pipe(
      take(1),
      tap(() => this.loading = false))
      .subscribe(() => {
        this.launchDialogService.closeDialog(this.mode);
      });
  }

  public close(reason: string): void {
    if (this.mode == GenFavotitesDialogActionsEnum.Edit) {
      this.list.name = this.fallbackName;
    }
    this.launchDialogService.closeDialog(reason);
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.close('close dialog');
  }
}
